import { Dispatch, SetStateAction, useMemo } from 'react'

import { SiteOrderBy, SiteSearchCondition } from '@/common/api/modules/site'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { Site } from '@/common/model/site'

import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import ListHeaderSortButton from '@/components/view/atoms/icon/ListHeaderSortButton'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import SiteListRow from '@/components/container/modules/admin/site/table/SiteListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

interface TheadProps extends ListFollowTableHeaderProps {
  // selected: boolean
  // allSelected: boolean
  // onCheck(checked: boolean): void
  // orderBy: SiteOrderBy | null
  // onChangeOrderBy(orderBy: SiteOrderBy | null): void
  float?: boolean
}

const Thead = ({
  // selected,
  // allSelected,
  // onCheck,
  // orderBy,
  // onChangeOrderBy,
  float = false,
  isScrolled,
  rowRefs,
  rowRects
}: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem checkbox sticky={0} float={float} {...rectProps(0)}>
        <Text size={12} color={TextColor.SECONDARY}>
          ID
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(1)}>
        <Text size={12} color={TextColor.SECONDARY}>
          サイト名
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(2)}></TableHeadItem>
      <TableHeadItem float={float} {...rectProps(3)}>
        <Text size={12} color={TextColor.SECONDARY}>
          サイトURL
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(4)}>
        <Text size={12} color={TextColor.SECONDARY}>
          プロジェクト番号
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(5)}>
        <div className='flex justify-center'>
          <Text size={12} color={TextColor.SECONDARY}>
            環境
          </Text>
        </div>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(6)}>
        <div className='flex justify-center'>
          <Text size={12} color={TextColor.SECONDARY}>
            状態
          </Text>
        </div>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(7)}>
        <div className='flex justify-center'>
          <Text size={12} color={TextColor.SECONDARY}>
            連動データ
          </Text>
        </div>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(8)}>
        <Text size={12} color={TextColor.SECONDARY}>
          機能設定
        </Text>
      </TableHeadItem>
    </>
  )
}

interface Props {
  sites: Site[]
  // reload(): void
  // selectedIds: number[]
  // onSelect(id: number): void
  // onSelectAll(checked: boolean): void
  condition: SiteSearchCondition
  setCondition: Dispatch<SetStateAction<SiteSearchCondition>>
  onUpdatePage: (page: number) => void
  total: number
}

const SITE_TABLE_COLUMN_LENGTH = 9

const SiteListTable = ({
  sites,
  // reload,
  // selectedIds,
  // onSelect,
  // onSelectAll,
  condition,
  setCondition,
  onUpdatePage,
  total
}: Props) => {
  // const allSelected = useMemo(() => {
  //   return sites.every((site) => selectedIds.includes(site.id))
  // }, [sites, selectedIds])

  const listFollowProps = useListScrollFollow(SITE_TABLE_COLUMN_LENGTH)
  const { headerFloat, header } = listFollowProps

  const theadProps: TheadProps = {
    // onCheck: onSelectAll,
    // selected: selectedIds.length > 0,
    // allSelected: allSelected,
    // orderBy: condition.orderBy,
    // onChangeOrderBy: (orderBy: SiteOrderBy | null) => {
    //   setCondition((condition) => ({ ...condition, page: 1, orderBy }))
    // },
    ...header
  }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {sites.map((site: Site) => (
            <SiteListRow
              key={site.id}
              site={site}
              // selected={selected}
              // selected={selectedIds.includes(site.id)}
              // onSelect={() => onSelect(site.id)}
              isScrolled={header.isScrolled}
            />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
      // selectedIdsQuantity={selectedIds.length}
    />
  )
}
export default SiteListTable
